import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Классы для триггера фильтра/селектора в активном (не дефолтном) состоянии.
 * Кнопка заливается фирменным цветом целиком, а не только контуром — так
 * выбранный фильтр заметен сразу (фидбек 2026-08-10). Единый стиль для всех
 * фильтров CRM: Сделки, Клиенты, Задачи, Счета/Платежи, Аналитика, DatePeriodFilter.
 */
export const FILTER_ACTIVE_CLASS =
  "bg-primary text-primary-foreground border-primary hover:bg-primary/90 hover:text-primary-foreground [&_svg]:opacity-90";
